import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload, doPostFiles, doPutFiles } from './utils'

export const getManageProjectClosedLate = (request) => {
  const url = `${API_ROOT}/progress/admin/project/delay/tracking/search`
  return doPost(url, request)
}

export const getManageProjectTracking = (projectId) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectId}/form`
  return doGet(url)
}

export const saveTrackingNote = (request) => {
  const url = `${API_ROOT}/progress/admin/project/delay/save`
  return doPostFiles(url, request)
}

export const editTrackingNote = (projectVersionId, projectDelayId, request) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectVersionId}/edit/${projectDelayId}`
  return doPutFiles(url, request)
}

export const deleteTrackingNote = (projectVersionId, projectDelayId) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectVersionId}/delete/${projectDelayId}`
  return doDelete(url)
}

export const saveAttachments = (projectVersionId, projectDelayId, request) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectVersionId}/attachments/${projectDelayId}`
  return doPostFiles(url, request)
}

export const getDownload = (id, fileId) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${id}/attachments/${fileId}/download`
  return doDownload(url)
}

export const updateAttachments = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectVersionId}/attachments/${request.id}`
  return doPut(url, request)
}

export const deleteAttachments = (id, fileId) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${id}/attachments/${fileId}`
  return doDelete(url)
}

export const getAttachments = (id) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${id}/attachments`
  return doGet(url)
}

export const getTrackingNote = (projectVersionId, delayId) => {
  const url = `${API_ROOT}/progress/admin/project/delay/${projectVersionId}/form/${delayId}`
  return doGet(url)
}
